import { render, staticRenderFns } from "./ProjectDetailForm.vue?vue&type=template&id=24e95d2a&scoped=true&lang=pug&"
import script from "./ProjectDetailForm.vue?vue&type=script&lang=ts&"
export * from "./ProjectDetailForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectDetailForm.vue?vue&type=style&index=0&id=24e95d2a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e95d2a",
  null
  
)

export default component.exports